import React, { useLayoutEffect, useState } from 'react';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import Button from 'src/@vymo/ui/atoms/button';
import { ReactComponent as LeftIcon } from 'src/assets/icons/left.svg';
import { ReactComponent as RightIcon } from 'src/assets/icons/right.svg';
import styles from './index.module.scss';

function CustomYearHeader({
  'data-test-id': dataTestId = 'year-header',
  date,
  decreaseYear,
  increaseYear,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
}: ReactDatePickerCustomHeaderProps & {
  'data-test-id'?: string;
}) {
  const year = date.getFullYear();

  const [header, setHeader] = useState({
    startYear: '',
    endYear: '',
  });

  useLayoutEffect(() => {
    const startYear =
      document.querySelector(
        '.react-datepicker__year-wrapper > .react-datepicker__year-text:first-child',
      )?.innerHTML ?? '';

    const endYear =
      document.querySelector(
        '.react-datepicker__year-wrapper > .react-datepicker__year-text:last-child',
      )?.innerHTML ?? '';

    setHeader({
      startYear,
      endYear,
    });
  }, [year]);

  return (
    <div data-test-id={dataTestId} className={styles.customHeader}>
      <div
        data-test-id={`${dataTestId}-nav-left-wrapper`}
        className={styles.customHeader__nav__left}
      >
        <Button
          onClick={decreaseYear}
          disabled={prevYearButtonDisabled}
          className={styles.customHeader__nav__left__button}
          type="outlined"
          rounded
          isIcon
          size="small"
          iconProps={{
            icon: <LeftIcon />,
            iconPosition: 'left',
          }}
        />
      </div>
      <div
        data-test-id={`${dataTestId}-content-wrapper`}
        className={styles.customHeader__content}
      >
        <Button type="primary" variant="subtle" size="small">
          {header.startYear} - {header.endYear}
        </Button>
      </div>
      <div
        data-test-id={`${dataTestId}-nav-right-wrapper`}
        className={styles.customHeader__nav__right}
      >
        <Button
          onClick={increaseYear}
          disabled={nextYearButtonDisabled}
          className={styles.customHeader__nav__right__button}
          type="outlined"
          rounded
          isIcon
          size="small"
          iconProps={{
            icon: <RightIcon />,
            iconPosition: 'left',
          }}
        />
      </div>
    </div>
  );
}

export default CustomYearHeader;
